SUBTYPE_CONTENT_FITNESS